export const IDR_DATA_SLICE_KEY = "id";

export const IDR_CALLING_CODE = "62";

export const IDR_PAYMENT_METHODS: { label: string; value: string; disabled?: boolean }[] = [
  { label: "Bank transfer", value: "bank" },
  { label: "eWallet", value: "wallet" },
];

export const IDR_WALLET_PROVIDERS = [{ label: "GoPay", value: "gopay_idr" }];

export const IDR_SOURCE_OF_FUNDS = [
  { label: "Business Income", value: "Business Income" },
  { label: "Business Revenue", value: "Business Revenue" },
  { label: "Personal Savings", value: "Personal Savings" },
];

export const IDR_BENEFICIARY_TYPES = [
  { label: "Individual", value: "Individual" },
  { label: "Business", value: "Business" },
];

export const IDR_SOURCE_CURRENCIES = [{ label: "USD", value: "USD" }];
